import arrayReduce from 'fast-loops/lib/arrayReduce';

export default function findDOMNodes() {
  return arrayReduce(document.querySelectorAll('[data-fela-type]'), function (nodes, node) {
    var type = node.getAttribute('data-fela-type') || '';
    var media = node.getAttribute('media') || '';
    var support = node.getAttribute('support') ? 'support' : '';

    nodes[type + media + support] = node;
    return nodes;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/findDOMNodes.js
// module id = 163
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38